import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateFile = ({ directID, tcID = null, cgId = null, fileId, name }) => {
  let url = `/api/directs/${directID}/files/${fileId}`;
  if (tcID) {
    url = `/api/directs/${directID}/suppliers/${tcID}/files/${fileId}`;
  }

  if (cgId) {
    url = `/api/directs/${directID}/consortium_groups/${cgId}/files/${fileId}`;
  }

  axios.put(url, { name });
}
  

export const useUpdateDirectFile = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateFile,
    onSuccess: () => {
      enqueueSnackbar('File name was succesfully updated', {
        variant: 'success',
      });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
